import { Occupation } from './Occupation';

export default Occupation;
